import { Loader } from 'lucide-react';
import { useDocxSelection } from './selection/context';
import { SuggestionLoading } from './selection/SuggestionLoading';
import { VariableEditor } from './selection/VariableEditor';
import { VariableList } from './selection/VariableList';

/**
 * Step 2 right panel. Mirrors the review sidebar's list/editor toggle: shows the draft
 * editor while a field is open, otherwise the marked-fields list + Save bar.
 */
export default function DocxBuilderPanelSelection() {
  const { draft, isLoading, isSuggesting } = useDocxSelection();

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Loader className="h-5 w-5 animate-spin text-selise-blue" />
      </div>
    );
  }

  // Takes the panel while the AI reads the document. Checked before `draft` so a stray draft
  // cannot render the editor over a run in progress; the canvas stays interactive either way.
  if (isSuggesting) return <SuggestionLoading />;

  return draft ? <VariableEditor /> : <VariableList />;
}
